// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Preset Keywords for Onboarding
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export interface KeywordPreset {
  id: string
  name: string
  description: string
  icon: string
  keywords: string[]
  color: string
}

export const KEYWORD_PRESETS: KeywordPreset[] = [
  {
    id: 'economy',
    name: '경제 뉴스',
    description: '경제 관련 주요 이슈',
    icon: '📊',
    keywords: ['반도체', '전기차', '금리', '부동산', '코스피'],
    color: 'blue',
  },
  {
    id: 'tech',
    name: 'IT 트렌드',
    description: '최신 기술 동향',
    icon: '💻',
    keywords: ['ChatGPT', 'AI', '메타버스', '블록체인'],
    color: 'purple',
  },
  {
    id: 'sports',
    name: '스포츠',
    description: '스포츠 주요 뉴스',
    icon: '⚽',
    keywords: ['손흥민', '이강인', 'KBO', '프리미어리그'],
    color: 'green',
  },
  {
    id: 'politics',
    name: '정치/사회',
    description: '정치 및 사회 이슈',
    icon: '🏛️',
    keywords: ['정치', '경제', '사회', '국회'],
    color: 'red',
  },
  {
    id: 'entertainment',
    name: '연예/문화',
    description: '연예 및 문화 소식',
    icon: '🎬',
    keywords: ['K-POP', '드라마', '영화', '음악'],
    color: 'pink',
  },
]

// Default preset for first-time users (fallback)
export const DEFAULT_PRESET = KEYWORD_PRESETS[3] // 정치/사회
